import { SelectChangeEvent } from '@mui/material'
import React from 'react'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { useLookupDealerCollection } from '../../../../../hooks/useLookupedDealersCollection'
import { notifySuccess } from '../../../../../services/ToastifyService/ToastifyService'
import {
  closeModalFn,
  openModalFn,
} from '../../../../../utils/controllers/ModalController'
import { getComp } from '../../../../../utils/utils/DI'
import singleRequestStore from '../../../store/SingleRequestStore'
import { RequestType } from '../../../types/Request.type'
import { mapItemsToAvailableStatuses } from '../../../utils/mapItemsToAvaliableStatuses'
import { switchCurrentUpdateFunction } from '../../../utils/switchCurrentUpdateFunction'
import requestDrawerStore from '../RequestDrawerStore'

type ParamsType = {
  dealerId?: string | null
  orderIds?: number[]
  orderId?: number
  comment?: string
}

export const useDrawerContentStatus = (
  request: RequestType,
  onClose: () => void,
) => {
  const invalidate = useInvalidateQueries()
  const statusStore = getComp('StatusesStore')
  const dealersStore = getComp('DealersStore')
  const { getFittedDealers, dealers } = useLookupDealerCollection([request.id])

  const [value, setValue] = React.useState(request.status)
  const [comment, setComment] = React.useState('')
  const [dealerValue, setDealerValue] = React.useState('')

  const { goBack } = requestDrawerStore
  const { updateRequest, updateHistory, getComments } = singleRequestStore
  const { disableSaveBtn, shouldSelectDealer, shouldShowCommentField } =
    getFeatureState(request, value, dealerValue, comment)

  React.useEffect(() => {
    if ([1, 4, 7, 11].includes(request.status)) {
      getFittedDealers()
    }
  }, [request.id])

  const items = mapItemsToAvailableStatuses(
    request.status,
    statusStore.orderStatuses,
  )
  const onChange = (e?: SelectChangeEvent<any>) => {
    const targetValue = e?.target.value
    const currentValue = items.find((el: any) => el.id === targetValue)

    setValue(currentValue?.id ?? request.status)
  }

  const onDealerChange = (e: SelectChangeEvent<any>) => {
    const targetValue = e?.target.value
    const currentValue = dealersStore.collection.find(
      (el: any) => el.subjectId === targetValue,
    )
    setDealerValue(currentValue?.subjectId)
  }

  const onSuccess = (res: any, message: string) => {
    updateRequest(res)
    notifySuccess(message)
    invalidate(['requests-table'])
    updateHistory()
  }

  const onSave = () => {
    const currentFn = switchCurrentUpdateFunction(value)
    const message = value === 2 ? 'Дилер назначен' : 'Заявка обновлена'

    const params: ParamsType = {}
    if (value === 2) {
      params['dealerId'] = dealerValue
      params['orderIds'] = [request.id]
    } else if (value === 7) {
      params['orderId'] = request.id
      params['comment'] = comment
    } else {
      params['orderId'] = request.id
    }

    openModalFn['progress-backdrop']?.()

    currentFn(params)
      .then((res: any) => {
        if (res && !res?.Errors) {
          if (shouldShowCommentField) getComments(request.id)
          if (value === 10) onClose()
          onSuccess(res?.[0] ?? res, message)
          goBack()
        }
        closeModalFn['progress-backdrop']?.()
      })
      .catch(() => {
        closeModalFn['progress-backdrop']?.()
      })
  }

  return {
    items,
    value,
    onChange,
    shouldShowCommentField,
    comment,
    setComment,
    shouldSelectDealer,
    dealers,
    onDealerChange,
    dealerValue,
    onSave,
    disableSaveBtn,
    goBack,
  }
}

const getFeatureState = (
  request: RequestType,
  value: number,
  dealerValue: string | null,
  comment: string,
) => {
  const state = {
    shouldShowCommentField: value === 7 && request.status !== 7,
    shouldSelectDealer: value === 2 && 2 !== request.status,
    disableSaveBtn: false,
  }

  state.disableSaveBtn =
    value === request.status ||
    (state.shouldSelectDealer && !dealerValue) ||
    (state.shouldShowCommentField && !comment)

  return state
}
